import { Component, OnInit, ViewChild, ElementRef  } from '@angular/core';
import { Grupo } from 'src/app/admihair/api/dto/grupo';
import { PlanoContaEmpresa } from 'src/app/admihair/api/dto/plano-conta-empresa.';
import { GrupoService } from 'src/app/admihair/service/grupo.service';
import { Message } from 'primeng/api';
import { NgForm } from '@angular/forms';
import { Subgrupo } from 'src/app/admihair/api/dto/subgrupo';
import { Empresa } from 'src/app/admihair/api/dto/empresa';
import { UtilStorageService } from 'src/app/admihair/service/util-storage.service';
import { ErroService } from 'src/app/admihair/service/erro.service';
import { FormatacaoUtil } from 'src/app/admihair/util/formatacao-util';
import { PlanoContaEmpresaService } from 'src/app/admihair/service/plano-conta-empresa.service';
import { AuthUtil } from 'src/app/admihair/util/auth-util';
import { TributacaoEmpresaService } from 'src/app/admihair/service/tributacao-empresa.service';
import { TributacaoEmpresa } from 'src/app/admihair/api/dto/tributacao-empresa';
import { GrupoRequest } from 'src/app/admihair/api/dto/grupo-request';

@Component({
  selector: 'app-grupo-listar',
  templateUrl: './grupo-inserir.component.html',
  styleUrls: ['./grupo-inserir.component.scss']
})
export class GrupoInserirComponent implements OnInit {

  permissaoInserir: boolean = false;
  messages: Message[] = [{ severity: '', summary: '', detail: '' }];
  messagemVisivel: boolean = false;
  loading: boolean = false;
  empresaSelecionada?: Empresa;
  tipos: PlanoContaEmpresa[] = [];
  planoSelecionado: PlanoContaEmpresa = {};
  grupo: Grupo = {};
  grupoValido: boolean = true;
  modalSubgrupo: boolean = false;
  listaSubgrupos: Subgrupo[] = [];
  subgrupo: Subgrupo = {};
  tipoSelecionado: boolean = false;
  listaTributacoes: TributacaoEmpresa[] = [];
  mostrarTributacao: boolean = false;
  gridAtiva: boolean = false;
  progressoRequisicao: boolean = false;

  constructor(private grupoService: GrupoService,
    private planoContaEmpresaService: PlanoContaEmpresaService,
    private tributacaoEmpresaService: TributacaoEmpresaService,
    private utilStorageService: UtilStorageService,
    private erroService: ErroService) { }

  @ViewChild('mainForm') form?: NgForm;
  @ViewChild('filter') filter!: ElementRef;

  ngOnInit(): void {
    this.permissaoInserir = this.verificarPermissao('PERM_INSERIR_GRUPO');
    this.empresaSelecionada = this.utilStorageService.getEmpresa();
    this.carregarTipos();
  }

  carregarTipos(){
    if(this.empresaSelecionada?.id) {
      const codigos = [3, 4];
      this.planoContaEmpresaService.listarPorEmpresaECodigo(this.empresaSelecionada.id, codigos).subscribe({
        next: (data: PlanoContaEmpresa[]) => {
          this.tipos = data;
        },
        error: (err: any) => {
          this.messages = this.erroService.handleErro(err);
          this.messagemVisivel = true;
        }
      });
    }
  }

  salvar(){
    this.progressoRequisicao = true;
    if(this.listaSubgrupos.length < 1){
      this.progressoRequisicao = false;
      this.modalSubgrupo = true;
    } else {
      const grupoRequest: GrupoRequest = {
        descricao: this.grupo.descricao,
        empresa: this.empresaSelecionada,
        planoContaEmpresa: this.planoSelecionado,
        tributacaoEmpresa: this.grupo.tributacaoEmpresa,
        subgrupos: this.listaSubgrupos
      }
  
      this.grupoService.salvarGrupo(grupoRequest).subscribe({
        next: () => {
          this.progressoRequisicao = false;
          this.messages = this.erroService.handleSuccess();
          this.messagemVisivel = true;
          this.limparFormulario();
          this.listaSubgrupos = [];
          this.rolarTela();
        },
        error: (err: any) => {
          this.progressoRequisicao = false;
          this.messages = this.erroService.handleErro(err);
          this.messagemVisivel = true;
          this.rolarTela();
        }
      });

    }
  }

  adicionarSubgrupo(){
    if(this.planoSelecionado.codigo == 4){
      this.subgrupo.rateioBasico = this.subgrupo.rateioBasico ?
      this.subgrupo.rateioBasico : 0;
    } else {
      this.subgrupo.rateioBasico = 0;
    }
    this.subgrupo.descricao = FormatacaoUtil.removerCaracteresEspeciais(this.subgrupo.descricao);
    this.listaSubgrupos.push(this.subgrupo);
    this.subgrupo = {};
    this.grupoValido = true;
    this.gridAtiva = true;
  }
  editarSubgrupo(subgrupo: Subgrupo){
    this.subgrupo = subgrupo;
    this.removerSubgrupo(subgrupo);
  }
  removerSubgrupo(subgrupo: Subgrupo){
    const posicao = this.listaSubgrupos.indexOf(subgrupo);
    this.listaSubgrupos.splice(posicao, 1);
    if(this.listaSubgrupos.length === 0){
      this.grupoValido = false;
    }
  }

  verificarPermissao(nome: string): boolean{
    return AuthUtil.verificarPermissao(nome);
  }

  selecionaTipo(){
    this.tipoSelecionado = true;
    if(this.planoSelecionado.codigo == 3){
      this.buscarTributacoesPorEmpresa('DANFE');
    } else if (this.planoSelecionado.codigo == 4){
      this.buscarTributacoesPorEmpresa('RPS');
    }
  }

  buscarTributacoesPorEmpresa(tipo?: string){
    this.tributacaoEmpresaService.listarPorEmpresaETipo(this.empresaSelecionada?.id, tipo).subscribe({
      next: (data: TributacaoEmpresa[]) => {
        this.listaTributacoes = data;
        if(this.listaTributacoes.length > 1){
          this.mostrarTributacao = true;
        } else {
          this.grupo.tributacaoEmpresa = this.listaTributacoes[0];
          this.mostrarTributacao = false;
        }
      },
      error: (err: any) => {
        console.log(err);
      }
    })
  }

  selecionaTributacao(tributacao: TributacaoEmpresa){
    this.grupo.tributacaoEmpresa = tributacao;
  }

  limparFormulario(){
    this.form?.reset(); 
  }

  ocultarMensagem(){
    if(this.messagemVisivel){
      this.messagemVisivel = false;
    }
  }
  rolarTela(){
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }
}
